import Velocity from 'velocity-animate'

export default {
  name: 'expand-wrapper-transition',
  functional: true,
  render: (createElement, context) => {
    let data = {
      props: {
        name: 'expand-wrapper-transition',
        css: false
      },
      on: {
        beforeEnter (el) {
          const wrapper = document.createElement('div')
          wrapper.classList.add('asdfasfdasdf')
          wrapper.style.opacity = 0
          wrapper.style.height = '0px'
          wrapper.style.overflow = 'hidden'
          el.insertAdjacentElement('beforebegin', wrapper)
          wrapper.appendChild(el)
        },

        enter (el, done) {
          const wrapper = el.parentElement
          const h = el.offsetHeight
          Velocity(wrapper, {height: h, opacity: 1}, {
            duration: 250,
            complete: () => {
              wrapper.insertAdjacentElement('beforebegin', el)
              wrapper.remove()
              done()
            }
          })
        },

        beforeLeave (el) {
          const wrapper = document.createElement('div')
          el.insertAdjacentElement('beforebegin', wrapper)
          wrapper.appendChild(el)
          wrapper.style.overflow = 'hidden'
          wrapper.style.maxHeight = `${el.offsetHeight}px`
        },

        leave (el, done) {
          const wrapper = el.parentElement
          Velocity(wrapper, {maxHeight: '0px', opacity: 0}, {
            duration: 250,
            complete: () => {
              el.style.display = 'none'
              wrapper.insertAdjacentElement('beforebegin', el)
              wrapper.remove()
              done()
            }
          })
        }
      }

    }
    return createElement('transition', data, context.children)
  }
}
